module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Lamp2-ae3df406888d71fb52d3fe7ec27b7b87.svg";